module.exports = __webpack_public_path__ + "img/五星党建.852a6892.png";